import { Outlet, useLocation, useNavigate } from 'react-router';
import { useEffect } from 'react';
import { useInternetConnectionAlert } from '@/hooks/connection.hooks';
import { useTheme } from '@/hooks/theme.hooks';
import { OptionalComponent } from '@ui/optional-component/optional-component';
import { ThemeName } from '@/types/theme';
import WebinarPlusCorners from '@ui/webinar-plus-corners/webinar-plus-corners';
import { Backdrop } from '@/components/backdrop';
import { Resources } from '@/components/resources';

export default function FormWrapper(): JSX.Element {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();
  useInternetConnectionAlert();
  const { theme, usePjdTheme } = useTheme();

  useEffect(() => {
    if (pathname === '/') {
      navigate('/sign-in', { replace: true });
    }
  }, [pathname, navigate]);

  return (
    <>
      <div className="authentication">
        <div className="authentication-form-container">
          <div className="authentication-form">
            <Outlet />
            <OptionalComponent display={theme?.name === ThemeName.WEBINAR_PLUS}>
              <WebinarPlusCorners />
            </OptionalComponent>
          </div>
          <OptionalComponent display={!usePjdTheme}>
            <Resources />
          </OptionalComponent>
        </div>
        <Backdrop />
      </div>
    </>
  );
}
